// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(tabs)/_layout.tsx": { enumerable: true, get() { return require("/home/solucionestechn/public_html/Appventas-test/app/(tabs)/_layout.tsx"); } },
  "./(tabs)/explore.tsx": { enumerable: true, get() { return require("/home/solucionestechn/public_html/Appventas-test/app/(tabs)/explore.tsx"); } },
  "./(tabs)/index.tsx": { enumerable: true, get() { return require("/home/solucionestechn/public_html/Appventas-test/app/(tabs)/index.tsx"); } },
  "./+not-found.tsx": { enumerable: true, get() { return require("/home/solucionestechn/public_html/Appventas-test/app/+not-found.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("/home/solucionestechn/public_html/Appventas-test/app/_layout.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;